//
//
//
//
//
//
//
//

import {
  CRM_PIPELINE_PYTPRO,
  CRM_STATUS_PYTPRO,
  CRM_TAGS_PYTPRO,
} from '../../../const/amo'
import AllSections from '~/components/redesign/AllSections'

export default {
  name: 'CodingPytProPage',
  components: {
    AllSections,
  },
  data() {
    return {
      crmPipeline: CRM_PIPELINE_PYTPRO,
      crmStatus: CRM_STATUS_PYTPRO,
      crmTags: CRM_TAGS_PYTPRO,
    }
  },
}
